<template>
  <v-row
    :class="{
      'd-flex':
        $vuetify.breakpoint.xs || $vuetify.breakpoint.smAndDown,
    }"
  >
    <v-col
      v-for="(campaign, index) in cardData"
      :key="index"
      cols="12"
      xl="4"
      lg="5"
      sm="6"
      md="6"
    >
      <v-card class="colorDominant" elevation="3">
        <v-img
          class="mx-auto"
          width="100%"
          :aspect-ratio="2.9"
          position="center center"
          :src="campaign.image"
          @error="
            imageError({
              src: campaign.image,
              index,
              isCardPromotions: true,
              code: sportsOrCasino === 0
                ? campaign.code_promo
                : campaign.codigo,
            })
          "
          @load="someImageLoaded = true"
        ></v-img>

        <div class="backgroundFade pa-4">
          <!-- Sports -->
          <div v-if="sportsOrCasino === 0">
            <!-- Sport Title -->
            <v-card-title
              class="
                d-block
                text-truncate
                pa-0
              "
            >
              {{ campaign.titulo }}
            </v-card-title>

            <!-- Sport bonus -->
            <v-card-text
              class="subtitle-2 pa-0"
              style="color: LimeGreen; margin-bottom: 38px;"
            >
              {{
                $t("promotionMaxBonus", {
                  max_bonus: campaign.bonus_max
                    && Number(campaign.bonus_max) > 0
                      ? campaign.bonus_max
                      : campaign.bonus,
                })
              }}
            </v-card-text>

            <!-- Sport  description -->
            <v-card-text
              style="height:45px;"
              class="
                description-opacity
                overflow-y-auto
                pa-0
              "
            >
              {{ campaign.descricao }}
            </v-card-text>
          </div>

          <!-- Casino -->
          <div v-if="sportsOrCasino === 1">
            <!-- Casino Title -->
            <v-card-title
              class="
                d-block
                justify-space-between
                pa-0
              "
            >
              <!-- Titulo Cassino -->
              <div class="d-flex align-center">
                <span class="mr-1">
                  {{ campaign.title }}
                </span>

                <FreespinDetailDialog
                  :title="campaign.title"
                  :description="campaign.description"
                  :campaignGames="campaign.games"
                />
              </div>
            </v-card-title>
          
            <!-- Total de rodadas disponíveis -->
            <v-card-text
              class="pa-0"
            >
              <div
                class="subtitle-2 mb-3"
                style="color: LimeGreen;"
              >
                  {{ $t("roundsQuantity") }}:
                  {{ campaign.quantity }}
              </div>

              <!-- Casino  description -->
              <v-card-text
                style="height:45px;"
                class="
                  description-opacity
                  overflow-y-auto
                  pa-0
                "
              >
                {{ campaign.description }}
              </v-card-text>

              <!-- Rollover Infos -->
              <div>
                <div
                  v-if="campaign.rollover_completeness != 'unnecessary'"
                  >
                  <!-- :style="campaign.rollover_completeness == 'unnecessary' && 'color: grey;'" -->
                  <div class="d-flex">
                    <span>{{ $t("Deposit") }}</span>
                    <v-spacer></v-spacer>
                    <span>{{ $t("labelCurrency") }} {{ campaign.deposit_value || 0 }}</span>
                  </div>
    
                  <div class="d-flex">
                    <span>Rollover</span>
                    <v-spacer></v-spacer>
                    <span>
                      {{
                        campaign.rollover_completeness == "unnecessary"
                        ? "0"
                        : campaign.rollover_multiplier || 0 }}x
                    </span>
                  </div>

                  <!-- Cumprimento -->
                  <div class="d-flex">
                    <span>{{ $t("completeness") }}</span>
                    <v-spacer></v-spacer>
                    <span>
                      {{
                        campaign.rollover_completeness == "unnecessary"
                        ? "0"
                        : rolloverTotalCompleteness || 0
                      }} / {{ campaign.rollover_total || 0 }}
                    </span>
                  </div>
                </div>
  
                <!-- Barra Progresso do Rollover -->
                <template>
                  <v-progress-linear
                    v-if="campaign.rollover_completeness != 'unnecessary'"
                    :value="progressBarValue"
                    height="25"
                    class="my-4"
                  >
                    <strong>{{ progressBarValue || 0 }}%</strong>
                  </v-progress-linear>

                  <!-- <div v-else
                    style="height: 25px; color: grey;"
                    class="my-4 d-flex justify-center"
                  >
                    {{ $t("noRollover") }}
                  </div> -->
  
                </template>
  
                <!-- Iniciado em -->
                <div
                  class="
                    d-flex
                    align-center
                    subtitle-2
                  "
                >
                  <span>
                    {{ $t("startedAt") }}: {{ $handleDate(campaign.start_date).date }}
                  </span>
                </div>
              </div>
              

              <!-- Expira em -->
              <div
                class="
                  d-flex
                  align-center
                  subtitle-2
                  mb-4
                "
              >
                <span
                  v-if="campaign.expiresIn"
                  :class="campaign.expiresIn.class"
                >
                  {{ campaign.expiresIn.text }}
                </span>
                <v-skeleton-loader
                  v-else
                  type="text"
                  width="90px"
                ></v-skeleton-loader>
              </div>
            </v-card-text>

            <!-- Casino  description -->
            <!-- <v-card-text
              style="height:45px;"
              class="
                description-opacity
                overflow-y-auto
                pa-0
              "
            >
              {{ campaign.description }}
            </v-card-text> -->
          </div>

          <v-card-actions class="pa-0">
            <v-btn
              v-if="sportsOrCasino === 0"
              class="primary"
              block
              :loading="claimingFreespinId === campaign.id"
              @click="promotionDetail(campaign)"
            >
              {{ $t("knowMore") }}
            </v-btn>
            <v-btn
              v-else
              class="primary"
              block
              :disabled="
                claimingFreespinId !== 0 ||
                  campaign.rollover_completeness != 'unnecessary' &&
                    progressBarValue < 100
              "
              :loading="claimingFreespinId === campaign.id"
              @click="claimFreeSpin(campaign.id)"
            >
              {{ $t("claim") }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-col>

    <v-col>
      <v-alert
        v-if="(
          recomendedPromotions.length === 0
          && sportsOrCasino == 0
        ) || (
          showingItemsRecommendedForYou.length === 0
          && sportsOrCasino == 1
        )"
        class="d-flex align-center mb-0"
        text
        type="info"
        min-height="70"
        border="left"
      >
        <div v-if="recomendedPromotions.length === 0">
          {{ $t("noSportsPromoFound") }}
        </div>
        <div v-if="showingItemsRecommendedForYou.length === 0">
          {{ $t("newCasino.freespins.noCampaignsAvailable") }}
        </div>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import FreespinDetailDialog from "./FreespinDetailDialog.vue";
export default {
  name: "card-promotions",
  props: [
    "sportsOrCasino",
    "freespinsFilteredBySearch",
    "showingItemsRecommendedForYou",
    "recomendedPromotions",
    "imageError",
  ],

  components: {
    FreespinDetailDialog,
  },

  data: () => ({
    claimingFreespinId: 0,
    cardData: [],
    someImageLoaded: false,
    showRolloverInfos: false,
    rolloverTotalCompleteness: 0,
    progressBarValue: 0,
    depositValue: 0,
    rolloverMultiplier: 0,
    rolloverTotal: 0,
    possibleExtensions: ["png", "jpg", "jpeg", "webp"],
    interval: 0,
  }),

  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    disableClaim() {
      return this.progressBarValue < 100;
    }
  },
  
  watch: {
    sportsOrCasino: {
      handler: function () {
        this.handleCardDataUsage();
      },
      immediate: true,
    },

    recomendedPromotions() {
      this.handleCardDataUsage();
    },

    freespinsFilteredBySearch() {
      this.handleCardDataUsage();
    }
  },

  destroyed() {
    clearInterval(this.interval);
  },

  methods: {
    handleCardDataUsage() {
      this.cardData = [];
      if (this.sportsOrCasino === 0) {
        clearInterval(this.interval);
        this.cardData = this.recomendedPromotions;
      } else {
        this.cardData = this.freespinsFilteredBySearch;

        clearInterval(this.interval);
        this.interval = setInterval(() => {
          this.counterDateExpiration();
        }, 1000);

        this.cardData.forEach((item) => {
          if (item.rollover_completeness != "unnecessary") {
            let rolloverCompleteness = parseFloat(item.rollover_completeness);
            let rolloverTotal = parseFloat(item.rollover_total);

            if (rolloverCompleteness >= rolloverTotal) {
              this.rolloverTotalCompleteness = rolloverCompleteness;
              this.progressBarValue = 100;
            } else {
              this.rolloverTotalCompleteness = rolloverCompleteness;
              this.progressBarValue = (rolloverCompleteness / rolloverTotal) * 100;
            }
          }
        })
      }
    },

    claimFreeSpin(campaignId) {
      this.claimingFreespinId = campaignId;

      const body = {
        campaign_id: campaignId,
      };

      this.$axios
        .post("player/online/casino/freespins/claim", this.$formdata(body))
        .then((response) => {
          this.$store.commit("setNotification", {
            msg: response.data.message,
            color: "success",
          });

          this.$emit("fetchData");
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.claimingFreespinId = 0;
        });
    },

    promotionDetail(campaign) {
      this.$router.push({
        path: `/promotions/${campaign.id}`,
        query: { from: 'my-promotions' },
      });
    },

    counterDateExpiration() {
      this.cardData = this.cardData.map(
        (item) => {
          let countDownDate = new Date(item.final_date_to_claim).getTime().toString();

          // Get today's date and time
          let dateNow = new Date().getTime();

          // Find distance between now and the count down date
          let distance = countDownDate - dateNow;

          // Time calculations for days, hours, minutes and seconds
          let days = Math.floor(distance / (1000 * 60 * 60 * 24));

          let hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );

          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          // let seconds = Math.floor((distance % (1000 * 60)) / 1000);

          const expiresIn = {};

          if (distance < 0) {
            expiresIn.text = this.$t("expired");
            expiresIn.class = "orange--text";
          } else if (days >= 1) {
            expiresIn.text = `${this.$t("expiresIn")} ${new Date(
              item.final_date_to_claim
            ).toLocaleDateString()}`;
            expiresIn.class = "red--text";
          } else {
            if (hours < 10) {
              hours = "0" + hours;
            }

            if (minutes < 10) {
              minutes = "0" + minutes;
            }

            expiresIn.text = this.$t("newCasino.freespins.expiresIn", {
              hour: hours,
              minute: minutes,
            });
            expiresIn.class = "red--text";
          }

          return { ...item, expiresIn };
        }
      );
    },
  }
}
</script>

<style scoped>
.backgroundFade {
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) -16.67%,
    #000000 99.99%,
    #313131 100%
  );
}

.description-opacity {
  color: rgba(163, 163, 163, 1);
}
</style>